/*
 * The stable `@id` values every schema node on this site points at.
 *
 * They live in one import-free module so that the Person node (src/utils/authorProfile.js)
 * and the Organization node (src/utils/siteEntityGraph.js) can reference each other
 * without an import cycle. An `@id` is a permanent identifier: changing one of these
 * strings breaks every reference to it across the corpus, so treat them as fixed.
 */

export const SITE_URL = 'https://bluebear.ai';

export const ORGANIZATION_ID = `${SITE_URL}/#organization`;
export const WEBSITE_ID = `${SITE_URL}/#website`;
export const PLATFORM_ID = `${SITE_URL}/#platform`;
export const BEARCLAW_PRODUCT_ID = `${SITE_URL}/bearclaw#product`;

export const AUTHOR_PATH = '/phillip-joe';
export const AUTHOR_URL = `${SITE_URL}${AUTHOR_PATH}`;
export const AUTHOR_PERSON_ID = `${AUTHOR_URL}#person`;
